module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_682.a2efa637.webp";